import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Container,
} from "react-bootstrap";
import { MdKeyboardArrowDown } from "react-icons/md";
import Images from "../Images";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "../Actions/commonFunction";

function Subheader() {
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [showDropdown3, setShowDropdown3] = useState(false);
  const [showDropdown4, setShowDropdown4] = useState(false);
  const [showDropdown5, setShowDropdown5] = useState(false);
  const [showDropdown6, setShowDropdown6] = useState(false);
  const [showDropdown7, setShowDropdown7] = useState(false);
  const [showDropdown8, setShowDropdown8] = useState(false);

  const { account } = useSelector((state) => state?.user);

  const dispatch = useDispatch();

  return (
    <div className="subheader">
      <Container>
        <div className="d-block d-xl-flex align-items-center flexwrap">
          <Dropdown
            className="edaface_drop"
            onMouseLeave={() => setShowDropdown1(false)}
            onMouseOver={() => setShowDropdown1(true)}
          >
            <DropdownToggle className="ps-0">
              Cryptocurrencies <MdKeyboardArrowDown className="arrowsvg" />
            </DropdownToggle>
            <DropdownMenu className="py-2 px-3" show={showDropdown1}>
              <Link to="/">
                <img src={Images.doc} className="me-2 navicon" alt="icons" />{" "}
                Coin Ranking
              </Link>
              <Link to="/">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                Check Scam VAC
              </Link>
              <Link to="/">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                Crypto ETFs
              </Link>
            </DropdownMenu>
          </Dropdown>
          <Dropdown
            className="edaface_drop"
            onMouseLeave={() => setShowDropdown2(false)}
            onMouseOver={() => setShowDropdown2(true)}
          >
            <DropdownToggle>
              Cex Listing <MdKeyboardArrowDown className="arrowsvg" />
            </DropdownToggle>
            <DropdownMenu className="py-2 px-3" show={showDropdown2}>
              <Link to="/exchanges/CEX/spot">
                <img src={Images.doc} className="me-2 navicon" alt="icons" />{" "}
                Spot
              </Link>
              <Link to="/exchanges/CEX/derivatives">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                Derivatives
              </Link>
            </DropdownMenu>
          </Dropdown>
          <Dropdown
            className="edaface_drop"
            onMouseLeave={() => setShowDropdown3(false)}
            onMouseOver={() => setShowDropdown3(true)}
          >
            <DropdownToggle>
              Dex Listing <MdKeyboardArrowDown className="arrowsvg" />
            </DropdownToggle>
            <DropdownMenu className="py-2 px-3" show={showDropdown3}>
              <Link to="/exchanges/DEX/spot">
                <img src={Images.doc} className="me-2 navicon" alt="icons" />{" "}
                Spot
              </Link>
              <Link to="/exchanges/DEX/derivatives">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                Derivatives
              </Link>
            </DropdownMenu>
          </Dropdown>
          <Dropdown
            className="edaface_drop"
            onMouseLeave={() => setShowDropdown4(false)}
            onMouseOver={() => setShowDropdown4(true)}
          >
            <DropdownToggle>
              Trending <MdKeyboardArrowDown className="arrowsvg" />
            </DropdownToggle>
            <DropdownMenu className="py-2 px-3" show={showDropdown4}>
              <Link to="/">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                Top Gainer
              </Link>
              <Link to="/">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                Top Loser
              </Link>
              <Link to="/">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                Popular Crypto
              </Link>
              <Link to="/">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                New Arrivals
              </Link>
            </DropdownMenu>
          </Dropdown>
          <Dropdown
            className="edaface_drop"
            onMouseLeave={() => setShowDropdown5(false)}
            onMouseOver={() => setShowDropdown5(true)}
          >
            <DropdownToggle>
              Trade <MdKeyboardArrowDown className="arrowsvg" />
            </DropdownToggle>
            <DropdownMenu className="py-2 px-3" show={showDropdown5}>
              <Link to="/">
                <img src={Images.doc} className="me-2 navicon" alt="icons" />{" "}
                EdaFace Dex
              </Link>
              <Link to="/">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                P2P Market
              </Link>
              <Link to="/">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                Launchpad
              </Link>
            </DropdownMenu>
          </Dropdown>
          <Dropdown
            className="edaface_drop"
            onMouseLeave={() => setShowDropdown6(false)}
            onMouseOver={() => setShowDropdown6(true)}
          >
            <DropdownToggle>
              List Your Project <MdKeyboardArrowDown className="arrowsvg" />
            </DropdownToggle>
            <DropdownMenu className="py-2 px-3" show={showDropdown6}>
              <Link to="/">
                <img src={Images.doc} className="me-2 navicon" alt="icons" />{" "}
                List Presales
              </Link>
              <Link to="/exchanges">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                List Crypto
              </Link>
              <Link to="/exchanges">
                <img src={Images.square} className="me-2 navicon" alt="icons" />{" "}
                List Exchanges
              </Link>
            </DropdownMenu>
          </Dropdown>

          <Dropdown
            className="edaface_drop"
            onMouseLeave={() => setShowDropdown7(false)}
            onMouseOver={() => setShowDropdown7(true)}
          >
            <DropdownToggle>
              Profile <MdKeyboardArrowDown className="arrowsvg" />
            </DropdownToggle>
            <DropdownMenu className="py-2 px-3" show={showDropdown7}>
              {isEmpty(account) ? (
                <>
                  <Link to="/">
                    <img
                      src={Images.doc}
                      className="me-2 navicon"
                      alt="icons"
                    />{" "}
                    Register
                  </Link>
                  <Link to="/">
                    <img
                      src={Images.doc}
                      className="me-2 navicon"
                      alt="icons"
                    />{" "}
                    Login
                  </Link>
                </>
              ) : (
                <>
                  <p>{account?.EmailId}</p>
                </>
              )}
            </DropdownMenu>
          </Dropdown>
          <Dropdown
            className="edaface_drop"
            onMouseLeave={() => setShowDropdown8(false)}
            onMouseOver={() => setShowDropdown8(true)}
          >
            <DropdownToggle>
              Resources <MdKeyboardArrowDown className="arrowsvg" />
            </DropdownToggle>
            <DropdownMenu
              className="py-2 px-3"
              show={showDropdown8}
            ></DropdownMenu>
          </Dropdown>
        </div>
      </Container>
    </div>
  );
}

export default Subheader;
